module.exports = __webpack_public_path__ + "img/VerifyCredentials.21c9545a.jpeg";